// import { database as db } from 'firebase';
import Vue from 'vue';
import Vuex from 'vuex';

import { firebaseAction, firebaseMutations } from 'vuexfire';

import actions from './actions';
// import getters from './getters';

Vue.use(Vuex);

const QListStore = new Vuex.Store({
    namespaced: true,
    state: {
        projects: [],
        activeProject: {
            cues: [],
            layers: [],
            collaborators: [],
            notes: []
        },
        activeVersion: null,
        users: [],
        activeUser: {
            uid: null,
            profile_picture: '',
            username: '', 
            active_pay: false,
            subscription_level: 0,
            signInMethod: '',
            currentProject: null,
            projects: {}
        },
        showMode: false
    },
    getters: {
        projects: (state) => { return state.projects; },
        mostRecentProject: (state, getters) => {
            return getters.userProjects.length > 0 ? getters.userProjects[0] : null;
        },
        userProjects: (state, getters) => {
            const uid = getters.user['.key'];
            return state.projects.filter((proj) => {
                if (proj.ownerUID === uid) return true;

                let isCollab = false;
                if (proj.collaborators) {
                    const collabs = Object.keys(proj.collaborators);
                    isCollab = collabs.includes(uid);
                }

                return isCollab;
            }).sort((a, b) => {
                const timeA = new Date(a.lastChangedDate);
                const timeB = new Date(b.lastChangedDate);
                return timeB - timeA;
            });
        },
        userPendingInvites: (state, getters) => {
            return state.projects.filter((proj) => {
                if (proj.pendingCollaborators) {
                    const index = Object.values(proj.pendingCollaborators).findIndex((pc) => {
                        return pc.email === getters.user.email;
                    });

                    return index > -1;
                }

                return false;
            });
        },
        projectFromID: (state, getters) => (id) => {
            const projIndex = getters.projects.findIndex((proj) => {
                return proj.id === id;
            });

            if (projIndex > -1) {
                return getters.projects[projIndex];
            } 

            return null;
        },
        // User Getters
        users: (state) => { return state.users; },
        user: (state) => { return state.activeUser; },
        userByUID: (state, getters) => (uid) => {
            const userIndex = getters.users.findIndex((user) => {
                return user['.key'] === uid;
            });
            if (userIndex > -1) {
                return getters.users[userIndex];
            } 
            return null;
        },
        userProjectData: (state, getters) => {
            try {
                const currentUser = getters.user;
                const currentProject = getters.project;

                if (currentUser && currentProject) {
                    if (currentUser.projects) {
                        return currentUser.projects[currentProject.id];
                    }
                }
            } catch (e) {
                console.error(e);
            }
            return {};
        },

        // Project Getters
        project: (state) => { return state.activeProject; },
        projectPath: (state, getters) => {
            if (getters.currentVersion) {
                return `/projects/${getters.project.id}/versions/${getters.currentVersion.id}`;
            }

            return `/projects/${getters.project.id}`;
        },
        documentUrl: (state) => {
            return state.activeProject.documentUrl;
        },
        ownerUID: (state) => {
            return state.activeProject.ownerUID || null;
        },

        // Version Getters
        versions: (state, getters) => {
            const versions = getters.project.versions || [];
            return Object.values(versions);
        },
        versionByID: (state, getters) => (id) => {
            const vFilter = getters.versions.filter(v => v.id === id);
            if (vFilter.length > 0) {
                return vFilter[0];
            }

            return null;
        },
        currentVersion: (state, getters) => {
            if (state.activeVersion) {
                return getters.versionByID(state.activeVersion);
            }

            return null;
        },
        isLocked: (state, getters) => {
            if (getters.currentVersion) {
                return getters.currentVersion.locked || false;
            }   
            return getters.project.locked || false;
        },

        // Cue Getters
        cues: (state, getters) => {
            let cues = getters.project.cues || [];
            const version = getters.currentVersion;
            if (version) {
                cues = version.cues || [];
            }
            return Object.values(cues);
        },
        cuesByPage: (state, getters) => (pageNumber) => {
            return getters.cues.filter(cue => cue.pageNumber === pageNumber);
        },
        visibleCues: (state, getters) => (pageNumber) => {
            // const layerIDs = getters.visibleLayers.map(l => l.id);
            const layerIDs = getters.visibleLayerIDs;
            return getters.cuesByPage(pageNumber).filter((cue) => {
                return layerIDs.includes(cue.layer);
            });
        },
        cuesPerLayer: (state, getters) => (layerID) => {
            return getters.cues.filter(cue => cue.layer === layerID);
        },

        // Layers Getters
        layers: (state, getters) => {
            let layers = getters.project.layers || [];
            const version = getters.currentVersion;
            if (version) {
                layers = version.layers || [];
            }
            return Object.values(layers);
        },
        layerByID: (state, getters) => (id) => {
            try {
                const filter = getters.layers.filter(layer => layer.id === id);
                if (filter.length > 0) return filter[0];
            } catch (e) {
                console.error(e);
            }

            return null;
        },
        layerByCue: (state, getters) => (cue) => {
            return getters.layerByID(cue.layer);
        },
        visibleLayers: (state, getters) => {
            try {
                const userProjectData = getters.userProjectData;
                if (userProjectData && userProjectData.layers && userProjectData.layers.viewing) {
                    return userProjectData.layers.viewing.reduce((result, id) => {
                        const layer = getters.layerByID(id);
                        if (layer) result.push(layer);

                        return result;
                    }, []);
                }
            } catch (e) {
                console.error(e);
            }
            return [];
        },
        visibleLayerIDs: (state, getters) => {
            const layers = getters.visibleLayers || [];
            return layers.map((layer) => {
                return layer.id;
            });
        },
        showNotesLayers: (state, getters) => {
            try {
                const userProjectData = getters.userProjectData;
                if (userProjectData && userProjectData.layers) {
                    return userProjectData.layers.showNotes || [];
                }
            } catch (e) {
                console.error(e);
            }
            return [];
        },
        editableLayers: (state, getters) => {
            const uid = getters.user['.key'];
            if (uid) {
                if (!getters.user.active_pay) return [];
                if (getters.ownerUID === uid) return getters.layers;
                
                const collab = getters.collaboratorByUID(uid);
                if (collab) {
                    return getters.layers.filter((layer) => {
                        return collab.layers[layer.id];
                    });
                }
            }
            return [];
        },
        validLayers: (state, getters) => {
            if (getters.editableLayers.length > 0 && getters.visibleLayers.length > 0) {
                const editSet = new Set(getters.editableLayers.map(x => x.id));
                const visibleSet = new Set(getters.visibleLayers);
                const choices = Array.from(visibleSet).filter(
                    x => editSet.has(x.id)
                );
                return choices;
            }
            return [];
        },
        currentLayer: (state, getters) => {
            const userProjectData = getters.userProjectData;
            if (userProjectData && userProjectData.layers && userProjectData.layers.editing) {
                const editLayerID = userProjectData.layers.editing;
                if (getters.validLayers.findIndex(l => l.id === editLayerID) > -1) {
                    return getters.layerByID(editLayerID);
                }
            }
            return null;
        },

        // Collaborator Getters
        collaborators: (state, getters) => {
            const collaborators = getters.project.collaborators || [];
            return Object.values(collaborators);
        },
        pendingCollaborators: (state, getters) => {
            const pendingCollaborators = getters.project.pendingCollaborators || [];
            return Object.values(pendingCollaborators);
        },
        collaboratorByUID: (state, getters) => (uid) => {
            const filter = getters.collaborators.filter(collab => collab.uid === uid);
            if (filter.length > 0) {
                return filter[0];
            }
            return null;
        },

        // Note Getters
        notes: (state, getters) => {
            let notes = getters.project.notes || [];
            const version = getters.currentVersion;
            if (version) {
                notes = version.notes || [];
            }
            return Object.values(notes);
        },
        visibleNotes: (state, getters) => {
            const layerIDs = getters.visibleLayerIDs;
            const showNotes = getters.showNotesLayers;
            try {
                return getters.notes.filter((note) => {
                    const layerVisible = layerIDs.includes(note.layer);
                    const layerShowingNotes = showNotes.includes(note.layer);
                    return layerVisible && layerShowingNotes;
                });
            } catch (e) {
                console.error(e);
            }
            return [];
        },
        notesByPage: (state, getters) => (page) => {
            try {
                return getters.visibleNotes.filter((note) => {
                    return note.page === page;
                });
            } catch (e) {
                console.error(e);
            }
            return [];
        },
        // theme Getters
        showMode: (state) => {
            return state.showMode || false;
        }
    },
    mutations: {
        ...firebaseMutations
    },
    actions: {
        setProjectsRef: firebaseAction(({bindFirebaseRef}, { ref, options }) => {
            console.log('Binding projects ref');
            bindFirebaseRef('projects', ref, options);
        }),
        setActiveProject: firebaseAction(({bindFirebaseRef}, { ref, options }) => {
            console.log('Binding project ref');
            bindFirebaseRef('activeProject', ref, options);
        }),
        setUsersRef: firebaseAction(({bindFirebaseRef}, { ref, options }) => {
            console.log('Binding Users Ref');
            bindFirebaseRef('users', ref, options);
        }),
        setActiveUser: firebaseAction(({bindFirebaseRef}, { ref, options }) => {
            console.log('Binding User Ref');
            bindFirebaseRef('activeUser', ref, options);
        }),
        ...actions
    }
});

export default QListStore;


// WEBPACK FOOTER //
// ./sample/lib/vuex/Store.js